import clsx from 'clsx'
import { picto, pictoSmall } from './Loader.css'
import loaderPicto from './loader.svg'

type LoaderIconProps = {
  small?: boolean
}

export const LoaderIcon = ({ small = false }: LoaderIconProps) => {
  return (
    <img
      src={String(loaderPicto)}
      alt="Chargement en cours"
      className={clsx(picto, small ? pictoSmall : null)}
    />
  )
}
